export function AuthCodeModal({
  open,
  onHave,
  onNeed,
  onClose,
}: {
  open: boolean;
  onHave: () => void;
  onNeed: () => void;
  onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div className="w-full max-w-lg rounded-xl bg-white p-6 shadow-xl">
        <h2 className="text-xl font-semibold text-slate-900">
          Do you have your Companies House authentication code?
        </h2>
        <p className="mt-3 text-sm text-slate-600">
          You need a 6-character authentication code to file accounts. This is the same code you
          use to sign in to Companies House WebFiling – it was posted to your registered office
          when the company was incorporated.
        </p>
        <div className="mt-4 rounded-lg bg-slate-50 p-4 text-sm text-slate-700">
          <strong className="block text-slate-900">Don't have it?</strong>
          You can request a new one from Companies House. It is sent by post to your registered
          office and usually arrives within 5 working days.
        </div>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button onClick={onClose} className="btn-ghost">
            Back
          </button>
          <button onClick={onNeed} className="btn-ghost">
            I need to request one
          </button>
          <button onClick={onHave} className="btn-primary">
            Yes, I have it
          </button>
        </div>
      </div>
    </div>
  );
}
